import * as React from 'react';
import { Color, Emplacement, Marquage, Picto, Surface, Thumbnail, Dimensions, validationVisuel } from './iMonCompte';
import { RenderPicto } from './RenderPicto';
import Icons from './Icons';
import UploadPart from './upload/components/UploadPart';
import {getShopInfosInStorage} from "../cart/ShopInfos";
import {cmjnData} from "./upload/components/UpdateCmjn";

interface RenderContentFilesGlobalLineState {
  marquages?: Marquage[];
  colors?: Color[];
  emplacements?: Emplacement[];
  surfaces?: Surface[];
  pictogrammes?: Picto[];
  preview?: Thumbnail;
  dimensions?: Dimensions;
  cmjnCs?: cmjnData
  previewIsUpdated: boolean;
  canValidate?: boolean;
  withBeforeUploadStatusId?: number;
  isReupload?: boolean;
  sfc?:Surface;
  newGlb?: boolean;
}


export default class RenderContentFilesGlobalLine extends React.Component<any,
  RenderContentFilesGlobalLineState> {

  constructor(props: any) {
    super(props);
    this.state = {
      previewIsUpdated: false,
      withBeforeUploadStatusId: this.props.paniers[0].withBeforeUploadStatusId,
      isReupload: this.props.isReupload,
      sfc: this.props.surface
    };
  }

  _onDeleteFile = () => {
    if (this.props.onDeleteFile) {
      this.props.onDeleteFile();
    }
  }

  _onCanValidate = (canValidate: boolean) => {
    if (this.props.onCanValidate) {
      this.props.onCanValidate(canValidate);
    }
  }

  _previewIsUpdated = (state: boolean) => {
    if(state !== this.state.previewIsUpdated) {
      this.setState({previewIsUpdated: state});
    }
  }

  _onPreviewUpdated = (preview: any) => {
    this.setState({preview: preview}, () => {this._previewIsUpdated(true)});
  }

  _onDimensionsUpdated = (dimensions: any) => {
    this.setState({dimensions: dimensions});
  }

  _onCmjnUpdated = (cmjnCs: cmjnData) => {
    this.setState({cmjnCs});
  }
  
  _onWithBeforeStatusIdUpdated = (withBeforeUploadStatusId: number) => {
    this.setState({withBeforeUploadStatusId}, () => {
      if(this.props.onWithBeforeStatusIdUpdated) {
        this.props.onWithBeforeStatusIdUpdated(withBeforeUploadStatusId, this.props.paniers[0].creation_id, withBeforeUploadStatusId === 4);
      }
    });
  }

  showHideArticlesConcernes = (event: React.MouseEvent<HTMLSpanElement>) => {
    const idCurrent = 'articlesConcernes-' + this.props.identifier;
    this.showHideArticleConcerne(this.props.identifier);
    this.hideAllArticlesConcernes(idCurrent);
  }

  showHideArticleConcerne = (idCurrent: string, forceHide: boolean = false) => {
    const div = document.getElementById('articlesConcernes-' + idCurrent);
    const down = document.getElementById('icon-down-' + idCurrent);
    const up = document.getElementById('icon-up-' + idCurrent);
    const totalArticles = document.getElementById('totalArticlesConcernes-' + idCurrent);


    if (div) {
      const fleche = div.parentNode?.querySelector('.flecheDetails');
      if ((!div.classList.contains('showDetailsArticles')) && !forceHide) {
        div.classList.add('showDetailsArticles');
        div.style.maxHeight = `${div.scrollHeight}px`;
        div.parentElement?.classList.add('shadowDetailsArticles');
        fleche?.classList.remove('d-none');

        if (up) {
          up.style.display = 'block';
        }

        if (down) {
          down.style.display = 'none';
        }

        totalArticles?.classList.add('totalArticlesConcernesSelected');
      } else {
        div.style.maxHeight = `0px`;
        div.classList.remove('showDetailsArticles');
        div.parentElement?.classList.remove('shadowDetailsArticles');
        fleche?.classList.add('d-none');

        if (up) {
          up.style.display = 'none';
        }

        if (down) {
          down.style.display = 'block';
        }

        totalArticles?.classList.remove('totalArticlesConcernesSelected');
      }
    }
  }

  hideAllArticlesConcernes = (idCurrent: string) => {
    const detailsItems: any = document.querySelectorAll('div.detailsArticles');
    for (const item of detailsItems) {
      let idSplit = item.id;
      idSplit = idSplit.split('-');
      idSplit = idSplit[1] + '-' + idSplit[2];

      if ((item.id != idCurrent)) {
        this.showHideArticleConcerne(idSplit, true);
      }
    }
  }

  handleChangeRowValidationVisuelChecked = (array: validationVisuel) => {
    this.props?.handleChangeRowValidationVisuelChecked(array);
  }

  handleChangeNonConformeChecked = (array: validationVisuel) => {
    this.props?.handleChangeNonConformeChecked(array);
  }

  
  onChangeSurface  = (newSurfaceId: string, newSurfaceName: string) => {
    if(newSurfaceId && newSurfaceName) {
      this.setState({
          sfc: { ...this.state.sfc, id: newSurfaceId, nom: newSurfaceName}
        });
    }
}

  render() {
      const renderPicto = () => {
        let cartid = '';
        if (this.props.paniers[0]) {
          cartid = this.props.paniers[0].idCaddies;
        }
        return (
          <div>
            <RenderPicto picto={this.props.pictogramme} surface={this.state.sfc}
                         emplacement={this.props.emplacement}
                         id={this.props.identifier} cartId={cartid} color={this.props.color}
                         orderId={this.props.order.idCommande} previewIsUpdated={this.state.previewIsUpdated}
                         resetPreviewIsUpdated={this._previewIsUpdated}
                         numCommande={this.props.order.numCommande} preview={this.state.preview}
                         isBroderie={parseInt(this.props.marquage.id,10) === 4} cmjnCustom={this.state.cmjnCs}
                         activateBatAuto={this.props.activateBatAuto}/>
          </div>
        );
      };

      const renderNbArticlesConcernes = () => {
        return (
          <div className="mt-1">
            <button id={'totalArticlesConcernes-' + this.props.identifier}
                    className={'bg-grey py-1 totalArticlesConcernes px-2 cursor-pointer d-flex align-items-center' +
                      ' justify-content-between'}
                    style={{borderRadius: '20px', display: 'inline-flex'}}
                    onClick={e => this.showHideArticlesConcernes(e)}>
              <span>{this.props.nbArticles} article(s) <span className="display-mobile-none">concerné(s)</span></span>
              <Icons id={'icon-down-' + this.props.identifier} icon="arrow_drop_down" size={20}
                     style={{display: 'block'}}/>
              <Icons id={'icon-up-' + this.props.identifier} icon="arrow_drop_up" size={20} style={{display: 'none'}}/>
            </button>
          </div>
        );
      };

    const renderSurfaceEmplacementAndNbArticles = () => {
      let printColors = '';
      let nameMarquage = this.props.paniers[0].marquage;
      let dimensionsTransfer = '';
      let cmjnFromCs = false;
      let title = '';
      let typeTransfert;
      if (nameMarquage.indexOf('pf_') !== -1) {
        nameMarquage = nameMarquage.charAt(3).toUpperCase() + nameMarquage.slice(4);
      }
      nameMarquage = nameMarquage.charAt(0).toUpperCase() + nameMarquage.slice(1);

      if (this.props.paniers[0] && this.props.paniers[0].nb_couleurs_marquage && this.props.paniers[0].couleurs_marquage) {
        let str_colors = ' couleurs ';
        if (parseInt(this.props.paniers[0].nb_couleurs_marquage) === 1) {
          str_colors = ' couleur ';
        }
        printColors = nameMarquage + ' ' + this.props.paniers[0].nb_couleurs_marquage + str_colors + ': ' + this.props.paniers[0].couleurs_marquage;
      }
      if (getShopInfosInStorage().Ref === 'DT' && this.props.paniers[0]?.dimensions?.hauteur && this.props.paniers[0]?.dimensions?.largeur) {
        dimensionsTransfer = `${this.props.paniers[0].dimensions.largeur} cm x ${this.props.paniers[0]?.dimensions.hauteur} cm`;
        if (this.state.dimensions && this.state.dimensions?.largeur && this.state.dimensions?.hauteur) {
          dimensionsTransfer = `${this.state.dimensions.largeur} cm x ${this.state.dimensions.hauteur} cm`;
        }
      }

      if(this.state.cmjnCs?.cyan !== null) {
        title = `C: ${this.state.cmjnCs?.cyan} M: ${this.state.cmjnCs?.magenta} J: ${this.state.cmjnCs?.jaune} N: ${this.state.cmjnCs?.noir}`;
        cmjnFromCs = true;
      }

      if (getShopInfosInStorage().Ref === 'DT') {
        const idArticle = Number(this.props.paniers[0].idarticles_);
        if([405637, 405638, 405639, 488223].includes(idArticle)) {
          typeTransfert = this.props.paniers[0].article.produit.Titre;
        }
      }


      return (
          <div className="col-md-4 align-self-center surfaceName display-mobile-none">
            <div>
              <div className="text-uppercase">
                {dimensionsTransfer != '' ? (
                  <>{dimensionsTransfer}</>
                ) : (
                  <> {this.state.sfc?.nom} {this.props.emplacement.nom}</>
                )}
              </div>
              {typeTransfert && <div className="text-lowercase">
                  <span>{typeTransfert} </span>
                {cmjnFromCs && typeTransfert === "SERICOAT CE" && <span className={"pl-3 pr-3"} title={title}
                                     style={{border: "1px solid black", width: 20, backgroundColor: `#${this.state.cmjnCs?.hexadecimal}`}}>&nbsp;</span>}
              </div>}
              {printColors !== '' &&
                <div className='bold'>{printColors}</div>
              }
            </div>
            {renderNbArticlesConcernes()}
          </div>
        );
      };

      const activateBatAuto = this.props.activateBatAuto;
      const renderImportButton = () => {
        const key = 'btnImport-' + this.props.marquage.id + '-' + this.state.sfc?.id + '-' +
          this.props.emplacement.id + '-' + this.props.pictogramme.id + '-' + this.props.color.Couleur + '-' +
          this.props.nbArticles + '-' + this.props.paniers[0].couleurs_marquage;
        return (
          <div className="col-md-8 p-0 align-self-center">
                <UploadPart paniers={this.props.paniers} surface={this.state.sfc} color={this.props.color}
                            emplacement={this.props.emplacement} order={this.props.order}
                            pictogramme={this.props.pictogramme} marquage={this.props.marquage}
                            nbArticles={this.props.nbArticles} identifier={this.props.identifier}
                            canGallerie={this.props.canGallerie} key={key}
                            canCustomDimensionsBatAuto={this.props.canCustomDimensionsBatAuto}
                            authorizedFiles={this.props.authorizedFiles} onDeleteFile={this._onDeleteFile}
                            onChangeSurface={this.onChangeSurface}
                            onCanValidate={this._onCanValidate} onPreviewUpdated={this._onPreviewUpdated}
                            onDimensionsUpdated={this._onDimensionsUpdated}
                            onCmjnUpdated={this._onCmjnUpdated}
                            onWithBeforeStatusIdUpdated={this._onWithBeforeStatusIdUpdated}
                            hasClientFiles={this.props.hasClientFiles}
                            activateBatAuto={activateBatAuto}
                            isBatAutoBroderie={this.props.isBatAutoBroderie}
                            isInternalUser={this.props.isInternalUser}
                            contourCustom={this.props.contourCustom}
                            customerChoixBroderie={this.props.customerChoixBroderie}
                            isInternalUserAdmin={this.props.isInternalUserAdmin}
                            canUpdateFichierDestructure={this.props.canUpdateFichierDestructure}
                            canUploadFichierDT={this.props.canUploadFichierDT}
                            canUpdateCmjn={this.props.canUpdateCmjn}
                            canDownloadEmbroidery={this.props.canDownloadEmbroidery}
                            canCheckImageUsage={this.props.canCheckImageUsage}
                            canUpdateOutlineProcessing={this.props.canUpdateOutlineProcessing}
                            activateCheckImageUsage={this.props.activateCheckImageUsage}
                            customerView={this.props.customerView}
                            onOrderUpdated={this.props.onOrderUpdated}
                            handleChangeRowValidationVisuelChecked={this.handleChangeRowValidationVisuelChecked}
                            handleChangeNonConformeChecked={this.handleChangeNonConformeChecked}
                            keyVisuel={this.props.keyVisuel} updateTextureGlb={this.props.updateTextureGlb}
                            onQueueGlBTexture={this.props.onQueueGlBTexture} />
          </div>
        );
      };

      const renderLigneGlobale = () => {
        return (
          <div
            className="row m-0 d-flex align-items-center p-2 position-relative lineGlobale"
            key={this.props.identifier}
          >
            <span className="text-uppercase surfaceNameResponsive col-12 d-none p-0 bold">
              {this.state.sfc?.nom} {this.props.emplacement.nom}
            </span>
            <div className="col-md-1 col-4 p-0 align-self-start align-self-md-center  mt-2 mt-md-0">
              {renderPicto()}
              <div className="d-none display-mobile">{renderNbArticlesConcernes()}</div>
            </div>

            <div className="col-md-11 col-8 d-flex pr-0">
              {renderSurfaceEmplacementAndNbArticles()}
              {renderImportButton()}
            </div>
            <div className="triangle-code position-absolute d-none flecheDetails"></div>
          </div>
        );
      };

      const renderLigneGlobale3d = () => {
        return (
            <div
              className="m-0 d-flex align-items-center p-2 position-relative lineGlobale flex-column w100"
              style={{ minHeight: 130 }}
              key={this.props.identifier}
            >
              <span className="text-uppercase surfaceNameResponsive d-none p-1 bold">
                {this.state.sfc?.nom} {this.props.emplacement.nom}
              </span>
              
              <div className="d-flex p-1 w100 w-100 justify-content-between">
                {renderSurfaceEmplacementAndNbArticles()}
                {renderImportButton()}
              </div>
              <div className="triangle-code position-absolute d-none flecheDetails"></div>
              <div className="d-none display-mobile text-center">{renderNbArticlesConcernes()}</div>
            </div>
        );
      };
      
      const is3d = this.props.paniers[0].isModel3d;

      return (
        <div key={this.props.marquage.id + '-' + this.state.sfc?.id + '-' + this.props.emplacement.id + '-' +
          this.props.pictogramme.id + '-' + this.props.color.Couleur + '-' + this.props.nbArticles + '-' + this.props.paniers[0].couleurs_marquage}
             className={`${activateBatAuto ? 'lineImportV2' : ''} ${is3d ? 'd-flex' : ''}`}>
          {this.props.paniers[0].isModel3d && parseInt(this.props.paniers[0].panachage,10) === 0 ? renderLigneGlobale3d() : renderLigneGlobale()}
        </div>
      );
  }
}